import { render, staticRenderFns } from "./OtherServicesCurrent.vue?vue&type=template&id=60213d4a&"
import script from "./OtherServicesCurrent.vue?vue&type=script&lang=js&"
export * from "./OtherServicesCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports